module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M21 8h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1v6a1 1 0 0 0 1 1zm6 2h-8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V11a1 1 0 0 0-1-1zm-13 2.61V16h7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-7v3.39c0 .594-.528.788-1 .43l-6.652-5.174c-.468-.358-.46-.936.01-1.292L13 12.18c.47-.358 1-.164 1 .43z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/export-document-1.js
// module id = 1131
// module chunks = 14